import { FronteRetroFileItemType } from "../types/communication/communicationDataType"

export const isItemPartiallyOrTotallyFilled = (item: FronteRetroFileItemType) => {
    const hasFronteItems = item?.front?.length > 0
    const hasRetroItems = item?.retro?.length > 0
    return (hasFronteItems || hasRetroItems)
}

export const addFronteRetroNewEmptyItemIfNeeded = (newList: FronteRetroFileItemType[]) => {
    // Add new fronte-retro item if last item is being filled
    const listLength = newList?.length
    if (listLength > 0) {
        const lastItemFilled = isItemPartiallyOrTotallyFilled(newList[listLength - 1])
        if (lastItemFilled) {
            newList.push(new FronteRetroFileItemType())
        }
        return newList
    }
    return newList;
}

export const removeEmptyFronteRetroItems = (newList: FronteRetroFileItemType[]) => {
    return [...newList].filter(item => isItemPartiallyOrTotallyFilled(item))
}

export const isPdfFile = (mimetype?: string) => {
    return !!(mimetype && mimetype?.indexOf('/pdf') >= 0)
}